export default "__VITE_ASSET__Cpq4_E1q__"